import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Breadcrumb } from '@/ui/components/common/Breadcrumb'
import { investigationsRoute } from '@/ui/pages/management/investigations'
import { CreateInvestigationFormSection } from './components/CreateInvestigationFormSection'

export const investigationsCreateRoute = createRoute({
  getParentRoute: () => investigationsRoute,
  path: 'create',
  component: CreateInvestigationPage,
})

export function CreateInvestigationPage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <Breadcrumb
        items={[
          { label: t('admin.nav_investigations'), href: '/manage/investigations' },
          { label: t('admin.form_create_title') },
        ]}
      />
      <CreateInvestigationFormSection />
    </div>
  )
}
